import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import Typography from '../../components/Basics/Typography'
import { HEALTH_STATES } from './healthStatus'

const LABEL_WIDTH = '70px'
const STRIP_MIN_WIDTH = '680px'

export const HealthLegend = () => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px', margin: '0 0 10px 0' }}>
    {[0, 1, 2, '-1'].map(code => (
      <span key={code} style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#4F4F4F' }}>
        <span
          style={{
            width: '14px',
            height: '14px',
            marginRight: '5px',
            display: 'inline-block',
            border: '1px solid rgba(0,0,0,0.15)',
            backgroundColor: HEALTH_STATES[code].color
          }}
        />
        {HEALTH_STATES[code].label}
      </span>
    ))}
  </div>
)

/**
 * The HealthTimeline's component (view "Línea de tiempo por camión").
 * Renders each truck's health strip exactly as the backend computed it —
 * no client-side recomputation of states.
 */
const HealthTimeline = ({ salud }) => {
  const { celdas = [], camiones = [], strips = {}, generado } = salud

  const sortedTrucks = [...camiones].sort((a, b) => {
    const issueRank = truck => ((strips[truck] || []).some(code => code === 1 || code === 2) ? 0 : 1)
    return issueRank(a) - issueRank(b) || a.localeCompare(b)
  })

  const axisLabels = [celdas[0], celdas[Math.floor(celdas.length / 2)], celdas[celdas.length - 1]]

  return (
    <Box style={{ marginTop: '30px' }}>
      <Typography variant="h2" margin="0 0 10px 0">
        Línea de tiempo por camión (últimas 48 horas)
      </Typography>
      <HealthLegend />
      <div style={{ overflowX: 'auto' }}>
        <div style={{ minWidth: STRIP_MIN_WIDTH }}>
          {sortedTrucks.map(truck => (
            <div key={truck} style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
              <span style={{ width: LABEL_WIDTH, flexShrink: 0, fontSize: '12px', fontWeight: 'bold' }}>{truck}</span>
              <div style={{ display: 'flex', flex: 1, gap: '1px' }}>
                {celdas.map((cell, index) => {
                  const code = (strips[truck] || [])[index]
                  const state = HEALTH_STATES[code] || HEALTH_STATES['-1']
                  return (
                    <div
                      key={`${truck}-${index}`}
                      title={`${truck} · ${cell} · ${state.label}`}
                      style={{ flex: 1, height: '14px', backgroundColor: state.color }}
                    />
                  )
                })}
              </div>
            </div>
          ))}
          <div style={{ display: 'flex', marginTop: '4px' }}>
            <span style={{ width: LABEL_WIDTH, flexShrink: 0 }} />
            <div
              style={{
                display: 'flex',
                flex: 1,
                justifyContent: 'space-between',
                fontSize: '11px',
                color: '#828282'
              }}
            >
              {axisLabels.map((label, index) => (
                <span key={`axis-${index}`}>{label}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Typography variant="body2" margin="8px 0 0 0" color="gray">
        Actualizado {generado}
      </Typography>
    </Box>
  )
}

HealthTimeline.propTypes = {
  salud: PropTypes.object.isRequired
}

export default HealthTimeline
